import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  findAllPaymentMethod,
  insertOrUpdatePaymentMethod,
  deletePaymentMethod,
  findByIDPaymentMethod,
} from "./paymentMethod.service";
import { IPaymentMethod, IPaymentMethodState } from "./paymentMethodModel";

const initialState: IPaymentMethodState = {
  loading: false,
  formLoading: false,
  error: "",
  PaymentMethodList: [],
  PaymentMethodID: null,
  PaymentMethodDetail: {
    UPI: "",
    BankAccountName: "",
    QRCodeImage: "",
    QRCodeImagePath: "",
  },
  isDeleteModalOpen: false,
  DeletePaymentMethodID: null,
};

const paymentMethodSlice = createSlice({
  name: "paymentMethod",
  initialState,
  reducers: {
    setPaymentMethodID: (state, action: PayloadAction<string | null>) => {
      state.PaymentMethodID = action.payload;
    },
    clearPaymentMethodDetails: (state) => {
      state.PaymentMethodDetail = initialState.PaymentMethodDetail;
      state.PaymentMethodID = null;
    },
    openDeleteModal: (state, action: PayloadAction<string>) => {
      state.DeletePaymentMethodID = action.payload;
      state.isDeleteModalOpen = true;
    },
    closeDeleteModal: (state) => {
      state.isDeleteModalOpen = false;
      state.DeletePaymentMethodID = null;
    },
  },
  extraReducers: (builder) => {
    // Find All
    builder.addCase(findAllPaymentMethod.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      findAllPaymentMethod.fulfilled,
      (state, action: PayloadAction<IPaymentMethod[]>) => {
        state.loading = false;
        state.PaymentMethodList = action.payload || [];
        state.error = "";
      },
    );
    builder.addCase(findAllPaymentMethod.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PaymentMethodList = [];
    });

    // Insert or Update
    builder.addCase(insertOrUpdatePaymentMethod.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(insertOrUpdatePaymentMethod.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(insertOrUpdatePaymentMethod.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Find By ID
    builder.addCase(findByIDPaymentMethod.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(findByIDPaymentMethod.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.PaymentMethodDetail = action.payload;
    });
    builder.addCase(findByIDPaymentMethod.rejected, (state, action) => {
      state.formLoading = false;
      state.PaymentMethodDetail = initialState.PaymentMethodDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete
    builder.addCase(deletePaymentMethod.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePaymentMethod.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePaymentMethod.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  setPaymentMethodID,
  clearPaymentMethodDetails,
  openDeleteModal,
  closeDeleteModal,
} = paymentMethodSlice.actions;
export default paymentMethodSlice.reducer;
